class SubMenu {

    constructor() {
        this.body = document.body;
        this.menu = document.querySelector('.c-navigation__dropDown');
        this.trigger = document.querySelector('.c-navigation__dropDown-trigger');
        this.menuMask = document.querySelector('.l-masthead__overlay');

        if (!_.isNull(this.menu) && !_.isNull(this.trigger)) {
            this.init();
            this.bindEvents();
        }
    }

    init() {
        this.trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
                    
            if (this.menu.classList.contains('is-open')) {
                this.close();
            } else {
                this.open();
            }
        });
    }

    bindEvents() {
        if (_.isNull(this.menuMask) === false) {
            this.menuMask.addEventListener('click', () => {
                this.close();
            });
        }
    }

    open() {
        this.body.classList.add('menu-is-open');
        this.menu.classList.add('is-open');
        this.trigger.classList.add('is-open');
    }

    close() {
        this.body.classList.remove('menu-is-open');
        this.menu.classList.remove('is-open');
        this.trigger.classList.remove('is-open');
    }
}

module.exports = SubMenu;